import { c as _c } from "react/compiler-runtime";
import type { UserTimelineEventLabelAdded } from '@onefootprint/request-types/dashboard';
import { useTranslation } from 'react-i18next';
type LabelAddedEventProps = {
  data: UserTimelineEventLabelAdded['data'];
};
const LabelAddedEvent = t0 => {
  const $ = _c(11);
  const {
    data: t1
  } = t0;
  const {
    kind
  } = t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      keyPrefix: "auditTrail.timeline.labelAddedEvent"
    };
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  const {
    t
  } = useTranslation("entity-details", t2);
  let t3;
  if ($[1] !== kind || $[2] !== t) {
    t3 = kind === "active" ? t(_temp) : kind === "offboard_fraud" ? t(_temp2) : t(_temp3);
    $[1] = kind;
    $[2] = t;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const labelText = t3;
  let t4;
  if ($[4] !== t) {
    t4 = t(_temp4);
    $[4] = t;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== labelText) {
    t5 = <p className="text-label-2 text-primary">{labelText}</p>;
    $[6] = labelText;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== t4 || $[9] !== t5) {
    t6 = <div className="text-body-2 text-tertiary flex justify-start items-center gap-1 flex-wrap" data-testid="label-added-event-header">{t4}{t5}</div>;
    $[8] = t4;
    $[9] = t5;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  return t6;
};
export default LabelAddedEvent;
function _temp($) {
  return $.labels.active;
}
function _temp2($_0) {
  return $_0.labels.offboard_fraud;
}
function _temp3($_1) {
  return $_1.labels.offboard_other;
}
function _temp4($_2) {
  return $_2.as;
}